






























































import { Component, Vue } from "vue-property-decorator";
import { Sweep } from "@/params/Sweep";
import ScreenShotImageContents from "@/components/screenshot/ScreenShotImageContents.vue";
import {TagContentsParam} from "@/params/TagContentsParam";


@Component({
  components: {
    ScreenShotImageContents,
  }
})
export default class VrSpaceContents extends Vue {
  public $vrSpace: HTMLIFrameElement;

  private mpid = 'x9eWw1jJkqE';
  private mpSdk: any;
  private sweeps: Sweep[];
  private currentSweep: Sweep = null;
  private currentTag: any = null;
  private screenShotSrc: string = '';
  private isShownScreenShot: boolean = false;

  /**
   * Mattertagのクリックに表示するコンテンツの内容
   */
  private tags: TagContentsParam[] = [
    {
      sid: '0YcIsz8U6Y4',
      type: 'product',
      label: 'Product: プランプエッセンス（美容化粧液）',
      color: {r: 0.247, g: 0.247, b: 0.92},
      productContents: {
        contentNo: 1
      }
    },
    {
      // ムービー2：商品紹介
      sid: 'bJSTz0JqNWM',
      type: 'productMovie',
      label: 'Product:メキシコ トートバッグ',
      color: {r: 0.8, g: 0.27, b: 0.612},
      movieContents: {
        videoFileUrl: '/videos/product-movie-bag720.mp4',
        posterFileUrl: '/videos/product-movie-bag-poster.jpg'
      },
      productMovieContents: {
        contentNo: 1
      }
    },
    {
      // ムービー1
      sid: 'mCA8ZwZERVm',
      type: 'movie',
      label: 'Movie: 斎藤珈琲',
      color: {r: 0.718, g: 0.184, b: 0.184},
      movieContents: {
        titleText: '斎藤珈琲',
        captionText: '毎日、煎りたての珈琲が自宅に届く<br />こんなサービスがあったら良いなという想いからはじめました。<br />たくさんの協力者のもと、サービス・エリアを開発中。',
        videoFileUrl: '/videos/movie-coffee720.mp4',
        posterFileUrl: '/videos/movie-coffee-poster.jpg'
      }
    },
    {
      // ここもムービー1
      sid: '4D2A4NqLnJY',
      type: 'movie',
      label: 'Movie: 斎藤珈琲',
      color: {r: 0.718, g: 0.184, b: 0.184},
      movieContents: {
        titleText: '斎藤珈琲',
        captionText: '毎日、煎りたての珈琲が自宅に届く<br />こんなサービスがあったら良いなという想いからはじめました。<br />たくさんの協力者のもと、サービス・エリアを開発中。',
        videoFileUrl: '/videos/movie-coffee720.mp4',
        posterFileUrl: '/videos/movie-coffee-poster.jpg'
      }
    },
    {
      // ECプロダクト
      sid: 'MjWIiUCQSFi',
      type: 'product',
      label: 'Product: プランプエッセンス（美容化粧液）',
      color: {r: 0.247, g: 0.247, b: 0.92},
      productContents: {
        contentNo: 1
      }
    },
    {
      // ここもムービー2の商品紹介
      sid: 'd1mNWyJSiW5',
      type: 'productMovie',
      label: 'Product:メキシコ トートバッグ',
      color: {r: 0.8, g: 0.27, b: 0.612},
      movieContents: {
        videoFileUrl: '/videos/product-movie-bag720.mp4',
        posterFileUrl: '/videos/product-movie-bag-poster.jpg'
      },
      productMovieContents: {
        contentNo: 1
      }
    },
    {
      sid: 'IP01twRKfBz',
      type: 'music',
      label: 'Music:UNDERARROW',
      color: {r: 0.364, g: 0.364, b: 0.364},
      musicContents: {
        imageUrl: '/images/music-image.jpg',
        soundUrl: '/sounds/music-SlowDive.mp3',
        artistName: '',
        musicName: 'UNDERARROW',
        description: 'ベルリンを拠点とする音楽制作及びマスタリングスタジオ。Yaporigami名義でも知られる電子音楽家Yu Miyashitaにより運営。<br /><br />＜受賞歴＞<br />Cannes Lions, Silver (2014)<br />New York Festivals, Finalist Award x 3 (2014)<br />The One Show, Merit Award x 2 (2014)<br />Adfest, Bronze (2014)',
      }
    },
    {
      // 音楽コンテンツダミー
      sid: 'ddqDROHRkyY',
      type: 'music',
      label: 'Music:UNDERARROW',
      color: {r: 0.364, g: 0.364, b: 0.364},
      musicContents: {
        imageUrl: '/images/music-image.jpg',
        soundUrl: '/sounds/music-SlowDive.mp3',
        artistName: '',
        musicName: 'UNDERARROW',
        description: 'ベルリンを拠点とする音楽制作及びマスタリングスタジオ。Yaporigami名義でも知られる電子音楽家Yu Miyashitaにより運営。<br /><br />＜受賞歴＞<br />Cannes Lions, Silver (2014)<br />New York Festivals, Finalist Award x 3 (2014)<br />The One Show, Merit Award x 2 (2014)<br />Adfest, Bronze (2014)',
      }
    },
    {
      // ここはストリーミング1
      sid: '4Hjn53RGy6O',
      type: 'liveStreaming',
      label: 'LiveStreaming: Sky News',
      color: {r: 0.608, g: 0.51, b: 0.078},
      liveContents: {
        contentNo: 1
      }
    },
    {
      // ここはストリーミング2
      sid: 'vnzykcJl5wj',
      type: 'liveStreaming',
      label: 'LiveStreaming: SPACE (Official)',
      color: {r: 0.608, g: 0.51, b: 0.078},
      liveContents: {
        contentNo: 2
      }
    },
    {
      // ここはストリーミング3
      sid: 'Z9BUABaXRWm',
      type: 'liveStreaming',
      label: 'LiveStreaming: Explore Africa',
      color: {r: 0.608, g: 0.51, b: 0.078},
      liveContents: {
        contentNo: 3
      }
    },
    {
      // ECプロダクト
      sid: 'WYWYVSrvh5n',
      type: 'product',
      label: 'Product: プランプエッセンス（美容化粧液）',
      color: {r: 0.247, g: 0.247, b: 0.92},
      productContents: {
        contentNo: 1
      }
    }
  ];

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }


  /* LifeCycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      this.$vrSpace = <HTMLIFrameElement> this.$refs.vrSpace;
      this.$vrSpace.src = `https://my.matterport.com/show/?m=${this.mpid}&play=1&vr=0&lang=en&help=0&brand=0&hl=2`;
      this.$vrSpace.addEventListener('load', this.onSpaceLoad);
    });
  }


  /* Event Handler */
  private onSpaceLoad (): void {
    console.log('On VR Space Loaded');
    try {
      const showcase: any = window.MP_SDK.connect(
        document.getElementById('vr-space-iframe'),
        this.$store.state.matterport_sdk_key, // SDK Key
        '3.2'
      )
      .then(async (mpSdk) => {
        this.mpSdk = mpSdk;
        console.log('<<<<<<<<<LoadSDKSuccess>>>>>>>');
        console.dir(mpSdk);
        // Matterport VR上のオブジェクトの設定をする
        await this.setMpData();
        // 現在Sweepの更新プロセスを設定
        this.setSweepUpdate();
        // Mattertagクリックプロセス設置画
        await this.setMattertags();

        this.mpSdk.App.state.subscribe(async (appState) => {
          console.log('App State: ', appState);
          // ToDo appStateのphaseのタイミングによって初期化処理を入れる
          // コンテンツスタート

          if (appState.phase === "appphase.playing") {
            /*
            console.log('==========Start Sweep========');
            const pose = await this.mpSdk.Camera.getPose();
            console.log(pose.sweep);
             */
            /*
            let selectTag: TagContentsParam;
            this.tags.some(tag => {
              if (tag.sid === 'MjWIiUCQSFi') {
                selectTag = tag;
                return true;
              }
            });
            // イベントと併せてクリックされたMattertag情報を渡す
            this.$emit('click-tag', selectTag);
             */
          }
        });
        console.log('=========Camera=========');
        console.log(this.mpSdk.Camera);
      })
      .catch((error) => {
        console.log(error);
      });
    }
    catch (error) {
      console.log(error);
    }
  }

  private onTakeScreenShot (ev: MouseEvent): void {
    console.log('Take Screen Shot');
    const w: number = this.$vrSpace.clientWidth;
    const h: number = this.$vrSpace.clientHeight;
    const imgWidth: number = 1280;
    const imgHeight: number = Math.round(h * 1280 / w);

    const dimensions = { width: w, height: h };
    const options = { mattertags: false, sweeps: false, measurements: false };

    console.dir(this.mpSdk.Camera.takeScreenShot);

    this.mpSdk.Camera.takeScreenShot(dimensions, options)
    .then((screenShotUrl) => {
      this.screenShotSrc = screenShotUrl;
      this.isShownScreenShot = true;
    })
    .catch((err) => {
      console.log(err);
    });
  }

  private onCloseScreenShotImage (): void {
    this.screenShotSrc = '';
    this.isShownScreenShot = false;
  }

  /**
   * Matterport VR上のコンテンツをセットアップ
   */
  async setMpData (): Promise<any> {
    try {
      const modelData = await this.mpSdk.Model.getData();
      this.sweeps = modelData.sweeps;

      const mattertagsData = await this.mpSdk.Mattertag.getData();
      // すべてのMattertag情報を出力する
      console.log('Mattertags ', mattertagsData);

      // 不必要なMattertagを消去する
      /*
      const removeTags = ['ddqDROHRkyY', 'bJSTz0JqNWM'];
      for (let i: number = 0; i < removeTags.length; i++) {
        const sid = removeTags[i];
        await this.mpSdk.Mattertag.remove(sid);
      }
       */
      return Promise.resolve(0);
    }
    catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }

  /**
   * Sweepが変化した時に更新プロセスを実施する設定を行うメソッド
   * SDKのSweep.Eventを利用してアップデートを検知する
   */
  private setSweepUpdate (): void {
    this.mpSdk.on(this.mpSdk.Sweep.Event.ENTER, (from, to) => {
      // console.log('Leave: ' + from);
      // console.log('Enter: ' + to);

      this.sweeps.some(sweep => {
        if (sweep.uuid === to) {
          this.currentSweep = sweep;
          return true;
        }
      });
      // イベントと併せて現在のSweepを渡す
      this.$emit('update-sweep', this.currentSweep);
    });
  }

  /**
   * Mattertagの内容とクリック時の動作をセットアップする
   */
  private async setMattertags (): Promise<any> {
    try {
      for (let i = 0; i < this.tags.length; i++) {
        const tag: TagContentsParam = this.tags[i];
        // console.log(tag.sid);
        await this.mpSdk.Mattertag.editColor(tag.sid, tag.color);
        await this.mpSdk.Mattertag.editBillboard(tag.sid, {
          description: '',
          label: tag.label,
          media: {src: '', type: 'mattertag.media.none'}
        });
        // console.log(tag.color);
      }

      // SDKのMattertag.Eventを利用してクリックを検知する
      this.mpSdk.on(this.mpSdk.Mattertag.Event.CLICK, sid => {
        console.log('Click Tag: ' + sid);
        this.currentTag = sid;
        let selectTag: TagContentsParam;
        this.tags.some(tag => {
          if (tag.sid === sid) {
            selectTag = tag;
            return true;
          }
        });
        // イベントと併せてクリックされたMattertag情報を渡す
        this.$emit('click-tag', selectTag);
      });
    }
    catch(err) {
      console.log(err);
    }
  }

}
